import { createFileRoute } from '@tanstack/react-router'
import CreateFolderModalWrapper from '../../../../../../containers/plan-menu/components/create-folder-modal'
import { plansNewFolderSearchSchema } from '../search-schemas'

export const Route = createFileRoute(
  '/_authenticated/project/$projectId/_plans/newfolder/'
)({
  validateSearch: plansNewFolderSearchSchema,
  component: CreateFolderModalWrapper
})
